import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/simmons-symbol-white.png'


const _hoisted_1 = { class: "banner__left" }
const _hoisted_2 = { class: "burger" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "burger__icon" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "burger__icon" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "burger__icon" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "banner__left__branding-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_10 = { class: "banner__left__drop-down" }
const _hoisted_11 = { class: "banner__right" }
const _hoisted_12 = { class: "popover__user" }
const _hoisted_13 = { class: "popover__user__info" }
const _hoisted_14 = { class: "popover__items" }

import { ref } from 'vue';
import { useStore } from 'vuex';
import ProductSelect from './ProductSelect.vue';
import {
  SPopover,
  SUserAvatar,
  SPopoverContainer,
} from '@simmons/components';
import { handleLogoutClick } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  emits: ["onSidebarOpen"],
  setup(__props, { emit }: { emit: ({(e: 'onSidebarOpen', opened: boolean | undefined): void,
}), expose: any, slots: any, attrs: any }) {

const userAvatarBackgroundColor = '#cfcf4a';
const showUserModal = ref(false);
const store = useStore();
const user = store.getters['auth/user'];
const [userFirstName, userLastName] = user.name.split(' ');



const onSidebarToggle = (event: Event): void => {
  const element = event.target as HTMLInputElement;
  emit('onSidebarOpen', element.checked);
};

const openUserModal = (): void => {
  showUserModal.value = true;
};

const onCloseUserModal = (): void => {
  showUserModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SPopoverContainer), { class: "banner" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("input", {
              type: "checkbox",
              class: "burger__checkbox",
              disabled: showUserModal.value,
              checked: "",
              onChange: onSidebarToggle
            }, null, 40, _hoisted_3),
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ])
        ]),
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(ProductSelect)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(SUserAvatar), {
          rounded: true,
          size: 's',
          "fallback-background-color": userAvatarBackgroundColor,
          "user-first-name": _unref(userFirstName),
          "user-last-name": _unref(userLastName),
          onClick: openUserModal
        }, null, 8, ["user-first-name", "user-last-name"])
      ]),
      _createVNode(_unref(SPopover), {
        "is-popover-active": showUserModal.value,
        onToggle: onCloseUserModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(SUserAvatar), {
              rounded: true,
              size: 's',
              "fallback-background-color": userAvatarBackgroundColor,
              "user-first-name": _unref(userFirstName),
              "user-last-name": _unref(userLastName)
            }, null, 8, ["user-first-name", "user-last-name"]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h4", null, _toDisplayString(_unref(user).name), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(user).email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleLogoutClick)(_unref(store))))
            }, " Log out ")
          ])
        ]),
        _: 1
      }, 8, ["is-popover-active"])
    ]),
    _: 1
  }))
}
}

})